import React from 'react'
import { Button, Icon, Link, Separator, Text } from '@/ui'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { TypographyStyles } from '@/styles'

type AhaMomentsHeaderFooterProps = {
  backButtonText: string
  continueButtonText: string
  handleContinue: () => void
  handleBack: () => void
  continueDisabled?: boolean
  children: React.ReactNode
}

export const AhaMomentsBookeepingHeader = () => (
  <div className="w-full max-w-screen-lg px-4">
    <Link href="/dashboard" className="inline-flex items-center mt-4 text-sm">
      <Icon icon={regular('arrow-left')} className="mr-2 text-black" />
      <Text variant={TypographyStyles.BODY_XS}>Back to Dashboard</Text>
    </Link>
  </div>
)

export const AhaMomentsBookeepingFooter = ({
  backButtonText,
  continueButtonText,
  handleBack,
  handleContinue,
  continueDisabled,
}: Pick<
  AhaMomentsHeaderFooterProps,
  | 'backButtonText'
  | 'continueButtonText'
  | 'handleBack'
  | 'handleContinue'
  | 'continueDisabled'
>) => (
  <div className="flex flex-col items-center max-w-[800px] mx-auto p-0">
    <Separator />

    <div className="flex justify-between w-full mt-4">
      <Button variant="secondary" size="md" onClick={handleBack}>
        {backButtonText}
      </Button>

      <Button
        variant="primary"
        size="md"
        onClick={handleContinue}
        disabled={continueDisabled}
      >
        {continueButtonText}
      </Button>
    </div>
  </div>
)

export const AhaMomentsHeaderFooter: React.FC<AhaMomentsHeaderFooterProps> = ({
  backButtonText,
  continueButtonText,
  handleContinue,
  handleBack,
  continueDisabled,
  children,
}) => {
  return (
    <>
      <AhaMomentsBookeepingHeader />
      {children}
      <AhaMomentsBookeepingFooter
        backButtonText={backButtonText}
        continueButtonText={continueButtonText}
        handleBack={handleBack}
        handleContinue={handleContinue}
        continueDisabled={continueDisabled}
      />
    </>
  )
}
